import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const Base = ({ title, description, keywords, canonicalUrl }) => {
  return <Helmet>
    <title>{title}</title>
    {description ? <meta name='description' content={description}/> : ''}
    {keywords ? <meta name='keywords' content={keywords}/> : ''}
    <link rel="stylesheet" href="https://use.typekit.net/sxd8amq.css" />
    <link rel="apple-touch-icon" href="/apple-touch-icon.png" sizes="180x180"/>
    <link rel="icon" href="/favicon-32x32.png" type='image/png' sizes='32x32'/>
    <link rel="icon" href="/favicon-16x16.png" type='image/png' sizes='16x16'/>
    <link rel="manifest" href="/site.webmanifest"/>
    <link rel="mask-icon" href="/safari-pinned-tab.svg" color='#f36c27'/>
    <meta name="p:domain_verify" content="3c9a7807fc6d2579b84588783eda7645"/>
    {canonicalUrl ? <link rel="canonical" href={canonicalUrl}/> : ''}
    <meta name="msapplication-TileColor" content="#DA532C"/>
    <meta name="theme-color" content="#F36C27"/>
  </Helmet>;
};

Base.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  keywords: PropTypes.string,
  canonicalUrl: PropTypes.string,
};

export default Base;



// WEBPACK FOOTER //
// ./src/components/Head/Base.js